import {
  CHART_SUBSCRIBE_TYPE_PLAN_299,
  CHART_SUBSCRIBE_TYPE_PLAN_3999,
} from "@/utils/const.js";
import { risingAPI } from "@/api/baseApi";
import { getRisingToken } from "@/api/authToken";
import axios from "axios";

export default {
  namespaced: true,
  state: () => ({
    coinList: [],
    favoriteCoinKey: "favoriteCoin",
    coinAllList: [],
    defaultCoin: "",
  }),
  actions: {
    async fetchCoin({ commit, dispatch }) {
      try {
        const result = await risingAPI.get(`/coin`, {
          params: {
            wht: "binance",
          },
        });
        // console.log("result", result);

        if (result.data.error) {
          await commit("setCoin", []);
          return;
        }
        // console.log("result.data", result.data.data);

        await commit("setCoin", result.data.data);
        return dispatch("getCoinComboList");
      } catch (e) {
        console.error("fetchCoin error", e);
        commit("setCoin", []);
      }
    },
    setCoin({ commit }, coinList) {
      commit("setCoin", coinList);
    },
    async getCoinListAll({ state }) {
      return state.coinAllList;
    },
    async getChartSubscribeDefaultCoin({ rootState, commit, state }) {
      // console.log("getchart default coin", state.defaultCoin);

      if (state.defaultCoin == "") {
        const userStore = rootState.userInfo.chartInfo;
        if (userStore?.subsc_type === CHART_SUBSCRIBE_TYPE_PLAN_3999) {
          await commit("setDefaultCoin", "BTC");
          return "BTC";
        } else {
          const coinList = userStore?.chart_coin_list
            ? userStore.chart_coin_list.split(",")
            : [];
          await commit("setDefaultCoin", coinList[0]);
          return coinList[0];
        }
      } else {
        // await commit('setDefaultCoin',payload)
        return state.defaultCoin;
      }
    },
    async getCoinList({ state, rootState, dispatch }) {
      const userStore = rootState.userInfo.chartInfo;
      if (!userStore) {
        return [];
      }
      // console.log("state.coinList.length", state.coinList.length);

      if (state.coinList.length === 0) {
        await dispatch("fetchCoin");
      }
      // if (userStore?.subsc_type === CHART_SUBSCRIBE_TYPE_PLAN_3999) {
      return state.coinList;
      // } else {
      //   const coins = [];
      //   // const chartCoinList = 'BTC,XRP'
      //   const chartCoinList = userStore?.chart_coin_list;
      //   // console.log("chartCoinList", chartCoinList);
      //   if (!chartCoinList) return coins;
      //   else {
      //     const selectedCoinList = chartCoinList.split(",");
      //     selectedCoinList.forEach((coin) => {
      //       coins.push(state.coinList.find((ob) => ob.coin_code === coin));
      //     });
      //     return coins;
      //   }
      // }
    },
    async getCoinComboList({ state, rootState, dispatch }) {
      const userFavoriteList = rootState.userInfo.risingUserInfo.favorites_list;
      const coinList = await dispatch("getCoinList");
      return coinList.map((item) => {
        const selected =
          userFavoriteList.length > 0
            ? userFavoriteList.includes(item.coin_code)
            : item.coin_code === "BTC";
        // item.coin_code === "BTC";
        return {
          key: item.coin_code,
          value: item.coin_code,
          selected: selected,
          icon: item.coin_image_path,
        };
      });
    },
    getCoinCheckList({ state }) {
      return state.coinList.map((item) => {
        return {
          key: item.coin_code,
          value: item.coin_code,
          checked: false,
          icon: item.coin_image_path,
          name: "coins",
        };
      });
    },
    getFavoriteCoinList({ state }) {
      return (
        JSON.parse(localStorage.getItem(state.favoriteCoinKey)) ||
        state.coinList
      );
    },
    getFavoriteCoinList_2({ state, rootGetters }) {
      const coinList = this.getCoinList({ state });
      const favoriteCoins = rootGetters["userStore/favoriteList"] || [];
      return coinList.filter((coin) => favoriteCoins.includes(coin.coin_code));
    },
  },
  mutations: {
    setCoin(state, coinList) {
      state.coinList = coinList;
      state.coinAllList = coinList;
      // state.coinAllList = JSON.parse(JSON.stringify(coinList));
      // console.log("state.coinList", state.coinList);
    },
    setDefaultCoin(state, payload) {
      state.defaultCoin = payload;
      // console.log("state.defaultCoin", state.defaultCoin);
    },
  },
};
